import { makeStyles } from '@material-ui/core';

export const usePlanStructureCardStyles = makeStyles((theme) => ({
  root: ({ selected }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '10px',
    flex: 1,
    minWidth: 0,
    width: '100%',
    padding: '16px',
    boxSizing: 'border-box',
    borderRadius: '16px',
    cursor: 'pointer',
    overflow: 'hidden',
    textAlign: 'left',
    // Selected tint #f7faff is not yet in theme.palette.colors.
    backgroundColor: selected ? '#f7faff' : theme.textWhite.main,
    border: selected
      ? `1px solid ${theme.palette.colors.bluePrimaryMain}`
      : `1px solid ${theme.palette.colors.grey60}`,
  }),
  controls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  iconBox: ({ selected }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px',
    borderRadius: '12px',
    backgroundColor: selected ? theme.textWhite.main : theme.palette.colors.grey20,
  }),
  structureIcon: {
    width: '24px',
    height: '24px',
    color: theme.palette.colors.bluePrimaryMain,
  },
  radioIcon: {
    width: '24px',
    height: '24px',
    color: theme.palette.colors.bluePrimaryMain,
  },
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    width: '100%',
  },
  title: {
    color: `${theme.palette.primary.main} !important`,
    fontFamily: 'Inter, sans-serif !important',
    fontWeight: '700 !important',
    fontSize: '16px !important',
    lineHeight: '24px !important',
    letterSpacing: '0.32px !important',
  },
  description: {
    color: theme.palette.colors.grey110,
    fontFamily: 'Inter, sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px',
    letterSpacing: '0.28px',
  },
}));
